import Vue from 'vue'

const API_GET_OPEN_ID = '/api/wx/get_wx_wechat_token_2'

export default (code, state, success = null, failed = null) => {
  Vue.http.get(API_GET_OPEN_ID, {params: {code, state}})
    .then((resp) => {
      if (success) success(resp)
    })
    .catch((error) => {
      if (failed) failed(error)
    })
}



// WEBPACK FOOTER //
// ./src/api/auth/get-open-id.js